import { Component, OnChanges, SimpleChanges, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { BaseModel, FormGeneratorService } from '@ngx-resource-toolkit/core';
import { ToasterService } from 'angular2-toaster';
import { HttpClient } from '@angular/common/http';
import { ReferenceObjectModel } from '../reference/models/reference-object.model';
import { environment } from '../../../environments/environment';
import { ExportExcelModel } from '../export-excel/export-excel.model';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { ExportService } from '../services/export.service';

export class ActionParametre {
    cle: string; // "periode"
    idAction: number; // "11"
    libelle: string; // null
    taille: number; // null
    type: string; // "PER", "TEXT", "DATE"
    valeur: any;
    _explicitType: string = 'ActionParametre';
}
export class SelectionAction {
    label: string;
    id: number;
    listeParametres: Array<ActionParametre>;
    constructor(data?) {
        // super();
        if (!data) {
            data = {};
        }
        Object.assign(this, data);
    }
}

@Component({
    selector: 'selection',
    templateUrl: './selection.component.html',
})
export class SelectionComponent implements OnChanges, OnInit {
    public messageCR = '';
    @Input() selected: BaseModel[];
    @Input() actions: SelectionAction[];
    @Input() filtre: string; // Filtre des actions : F = Famille, ...
    @Input() anneeScolaire: number;

    @Output() selectedChanged = new EventEmitter(); // Pour indiquer à l'extérieur du component que la sélection a changé (par exemple
    // lors de la suppression d'un élément)
    @Output() selectedAllAsked = new EventEmitter(); // Demande la sélection de tous les éléments
    @Output() finished = new EventEmitter(); // Traitement terminé => demander à recharger les données si nécessaire

    // Comment faire car mes champs sont dynamiques, je ne sais ni combien de champs je vais avoir, ni de quels type ils seront ?
    // Il faut certainement un tableau associatif pour pouvoir tout récupérer...

    // public selectedparametres: Array<any> = []; // {value: string, label: string};
    // public newSelectedParametre: any; // Le dernier paramètre qui a changé

    public loading: boolean = false;
    public selectedAction: SelectionAction = null; // Action sélectionnée
    public parametresAction: Array<ActionParametre> = []; // Paramètres de l'action courante
    public listePeriodes: Array<{id: number, libelle: string}> = [];
    constructor(
        private http: HttpClient,
        private toaster: ToasterService,
        private formGenerator: FormGeneratorService,
        private exportService: ExportService,
    ) {

    }

    removeSelected(sel: BaseModel) {
        // this.selected = this.selected.filter(elt => elt['id'] !== sel['id']);
        const indiceElement: number = this.selected.findIndex(function(elt) { return elt['id'] === sel['id']; });
        if (indiceElement >= 0) {
            this.selected.splice(indiceElement, 1);
            this.selectedChanged.emit(this.selected);
        }
    }
    selectionParametreChange(cle, valeur, indexParam = -1) {
        // console.log('selectionParametreChange(cle)', cle, valeur, indexParam);
        // this.selectedAction.listeParametres[indexParam].valeur
        // this.selectedparametres[cle] = valeur;
        // inutile car on a rattaché le modèle au composant
        this.selectedAction.listeParametres[indexParam].valeur = valeur ? valeur.id : null;
    }

    selectAll() {
        this.selectedAllAsked.emit();
    }
    deselectAll() {
        this.selected = [];
        this.selectedChanged.emit(this.selected);
    }

    ngOnInit(): void {
        // console.log('SelectionComponent', 'ngOnInit', this.selected, this.filtre, this.anneeScolaire);
        // Rechercher les actions possibles pour le contexte
        const param = new ReferenceObjectModel();
        param.getResource('default', 'get')
            .call(this.http,
                'getActionsActives', // 'getReferenceObjects',
                [this.filtre, this.anneeScolaire]) // , [this.settings.getUserSetting('anneeScolaire')]
            .subscribe(
              (data) => {
                  // console.log('getActionsActives', data);
                  this.actions = [];
                    if (data instanceof Array) {
                        let lastAction = null;
                        data.forEach((action) => {
                            lastAction = new SelectionAction({label: action.libelle, id: action.id});
                            this.actions.push(lastAction);
                        });
                        if (data.length === 1) {
                            // Sélectionner la première action
                            this.actionIsSelected(lastAction);
                        }
                    }
              }, (err) => {
                  console.log('SelectionComponent', 'ERROR search ref_action', err);
                  this.toaster.pop('error', 'Erreur lors de la recherche des actions possibles');
              }
            );
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log('SelectionComponent', 'ngOnChanges', this.actions, this.filtre);
    }

    /**
     *
     * @param action Sélection d'une action
     */
    actionIsSelected(action) {
        this.messageCR = '';
        console.log('action sélectionnée :', action);
        // Vidage des paramètre en mémoire
        this.parametresAction = [];
        this.selectedAction = action;
        // Recherche s'il y a des paramètres
        // ServiceGeneric.selectParametresAction(action.id, chargeParametresActionSuccess, this);
        this.http.get(environment.proxyUrl + '/generic/selectParametresAction',
            {
              params: {
                'params': JSON.stringify([action.id]),
              }
            }
          ).subscribe((data: ActionParametre) => {
              if (data instanceof Array && data.length > 0) {
                console.log('Paramètres pour l action', action, data);
                // console.log("tu vois ça ", data);
                this.parametresAction = data;
                this.selectedAction.listeParametres = this.parametresAction;
                data.forEach((actionParametre, indexParam) => {
                    console.log('actionParametre', actionParametre);
                    /**
                     * cle:"periode"
                     * idAction:"11"
                     * libelle:null
                     * taille:null
                     * type:"PER"
                     * _explicitType:"ActionParametre" */
                    switch (actionParametre.type) {
                        case 'PER': // Periode
                            console.log('Action PERiode : recherche de la liste des options');
                            this
                                .http
                                .get(environment.proxyUrl + '/examen/searchGroupesExamens',
                                    // Pas besoin de paramètre mais si on ne met rien une chaine vide est passée au serveur
                                    {
                                        params: {
                                          'params': JSON.stringify([]),
                                        }
                                    }
                                )
                                .subscribe((dataOption) => {
                                    console.log('dataOption', dataOption);
                                    if (dataOption instanceof Array && dataOption.length > 0) {
                                        this.listePeriodes = dataOption;
                                        console.log("liste des options ", dataOption);
                                        /*dataOption.forEach(periode => {
                                        });*/
                                        this.selectedAction.listeParametres[indexParam].valeur = this.listePeriodes.length > 0 ? this.listePeriodes[0].id : null;
                                    } else {
                                        this.listePeriodes = [];
                                    }
                                });
                                /*id libelle */
                            break;
                        case 'DATE': // Date
                            const maDate = moment().format('YYYY-MM-DD');
                            console.log(maDate);
                            this.selectedAction.listeParametres[indexParam].valeur = maDate;
                            break;
                        case 'TEXT': // Texte
                            this.selectedAction.listeParametres[indexParam].valeur = '';
                            break;
                        // pas d'autres types acceptés pour le moment
                    }
                });
              } else {
                console.log('Aucun paramètre pour l action', action);
              }
          });
    }

    /**
     * Exécute l'action sélectionnée
     */
    executeAction() {
        console.log('executeAction:[action,liste-individus]', this.selectedAction, this.selected);
        // ServiceGeneric.genericFunction(functionId, listeObjets.toArray(), parametres
        // genericFunction($fonctionId, $listeObjets, $anneeScolaire, $listeParametres=null)
        // Préparation des paramètres
        // (this.selectedparametres.length===0) ? null : this.selectedparametres;
        let listeParametresAEnvoyer = null;
        if (this.selectedAction.listeParametres != null) {
            listeParametresAEnvoyer = new Object();
            this.selectedAction.listeParametres.forEach((param, indexParam) => {
                // console.log({ param, indexParam, cle: this.selectedAction.listeParametres[indexParam].cle});
                listeParametresAEnvoyer[this.selectedAction.listeParametres[indexParam].cle]
                    = this.selectedAction.listeParametres[indexParam].valeur;
                console.log('le param  ', indexParam);
                console.log('lobjet valeur ', this.selectedAction.listeParametres[indexParam].valeur);
                console.log('lobjet idAction ', this.selectedAction.listeParametres[indexParam].idAction);
                console.log('lobjet cle ', this.selectedAction.listeParametres[indexParam].cle);
                console.log('lobjet libelle ', this.selectedAction.listeParametres[indexParam].libelle);
            });
        }
        console.log('parametre', listeParametresAEnvoyer);
        this.selected = this.selected.sort((a, b) => {
            const enCollator = new Intl.Collator('fr');
            return enCollator.compare(a["libelle"], b["libelle"]);
        });
        console.log('executeAction:[liste triee]', this.selected);
        const selectedObjectsToSend = this.selected.map(x => +x["id"]); // = [];
        console.log('executeAction:[liste ids triee]', selectedObjectsToSend);
        /*if (this.selected) {
            this.selected.forEach((selected) => {
                // selectedObjectsToSend.push({typeObjet: selected['typeObjet'], id: selected['id']})
                selectedObjectsToSend.push(selected['id']);
            });
        }*/
        const objToSend = {typeObjet: 'F', selected: selectedObjectsToSend, sorted: true};
        // const objToSend = this.selected;
        const paramsAEnvoyer = JSON.stringify([this.selectedAction.id, objToSend, this.anneeScolaire, listeParametresAEnvoyer]);
        console.log('parametre', paramsAEnvoyer);
        this.loading = true;
        this.http
            .get(environment.proxyUrl + '/generic/genericFunctionBis', // '/generic/genericFunctionBis'
                {
                  params: {
                    'params': paramsAEnvoyer,
                  }
                }
              ).subscribe((data) => {
                console.log('executeAction resultat', data, this.selectedAction.id);
                  if (data['exception']) {
                    // Exception levée côté serveur
                    console.log('Exception serveur', data);
                    const codeErreur = data['code'];
                    if (codeErreur === 702) {
                        this.toaster.pop('info', data['message']);
                    } else if (codeErreur === 703) {
                        this.toaster.pop('info', data['message']);
                    } else {
                        this.toaster.pop('error', `Erreur lors de l\'exécution de l\'action ${this.selectedAction.label} : ${data['message']}`);
                    }
                    return;
                  }
                switch (this.selectedAction.id.toString()) {
                    case '3': { // Calcul factures
                        const nbFacturesGenerees: number = parseInt(data.toString());
                        this.messageCR = nbFacturesGenerees + ' factures générées.';
                        this.toaster.pop('info', this.messageCR);
                        break;
                    }
                    case '7': { // Validation factures
                        console.log('switch 7', this.selectedAction.id);
                        // TODO voir ce qui est fait dans Flex
                        const nbFactures: number = parseInt(data.toString());
                        if (nbFactures > 0) {
                            // signalParentController(CRGeneric.VALIDATED);
                            this.messageCR = nbFactures + ' factures validées.';
                            this.toaster.pop('info', this.messageCR);
                        } else {
                            this.messageCR = 'Aucune facture n\'a été validée.';
                            this.toaster.pop('warn', this.messageCR);
                        }
                        // MessageHelper.alerteInformation(nbFactures.toString() + " factures validées.");
                        this.actionTerminee();
                        break;
                    }
                    case '13': {
                        this.messageCR = 'L\'envoi des bulletins a bien été programmé.';
                        this.toaster.pop('info', this.messageCR);
                        break;
                    }
                    case '14': {
                        this.messageCR = 'L\'envoi des fiches de réinscriptions a bien été programmé.';
                        this.toaster.pop('info', this.messageCR);
                        break;
                    }
                    case '18' : {
                        this.messageCR = 'L\'envoi des liens familles a bien été programmé.';
                        this.toaster.pop('info', this.messageCR);
                        break;
                    }
                    case '19': {
                        this.messageCR = 'L\'envoi des confirmations d\'inscriptions a bien été programmé.';
                        this.toaster.pop('info', this.messageCR);
                        break;
                    }
                    case '1': // Fiche réinscription
                    case '2': // Etiquettes
                    case '4': // PDF Factures
                    default: { // TODO voir pour mettre un code action au retour dans la liste des actions possible en BDD
                        console.log('switch default', this.selectedAction.id);
                        const filenameOnDisk: string = data.toString();
                        const filename = this.selectedAction.label;
                        // console.log('saveAs', filenameOnDisk, filename);
                        const excelModel = new ExportExcelModel(filenameOnDisk, filename);
                        return excelModel.getResource('default', 'post').call(
                            this.http, 'getExportExcel.php', this.formGenerator.createFormGroup(excelModel, 'create'),
                            [], {
                            responseType: 'blob',
                            observe: 'response'
                            }
                        ).subscribe(
                            (res: any) => {
                                // console.log('res=', res);
                                // const blob = new Blob([res.body], {type: res.headers.get('Content-Type')});
                                // saveAs(blob, `${filename}.pdf`);
                                this.exportService.openInBrowser(res.body, 'application/pdf', `${filename}.pdf`);
                                this.actionTerminee();
                            }, (err) => {
                                console.log('ExportService', 'export error', err);
                                this.toaster.pop('error', `Erreur lors de l\'export ${filename}`);
                            }
                        );
                    }
                }
                  this.loading = false;
              }, (err) => {
                console.log('executeAction', 'error', err);
                this.loading = false;
                this.toaster.pop('error', `Erreur lors de l\'exécution de l\'action ${this.selectedAction.label}`);
              }
            );
    }

    actionTerminee() {
        this.finished.emit();
        this.deselectAll();
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/miscellaneous/selection.component.ts